export function searchWithXPathDeep(searchText: string): HTMLElement[] {
  // Skip non-visible elements
  const skipTags = ["SCRIPT", "STYLE", "META", "HEAD", "NOSCRIPT", "TITLE"];
  const skipSelector = skipTags.map((tag) => `not(self::${tag})`).join(" and ");

  // Escape the search text for XPath (handle quotes)
  const escapedSearchText = searchText.replace(/"/g, '\\"');

  // XPath to get all elements that contain the text and are not in skip list
  const xpath = `.//*[${skipSelector} and contains(., "${escapedSearchText}")]`;

  const result = window.document.evaluate(
    xpath,
    window.document.body,
    null,
    XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
    null
  );

  const elements: HTMLElement[] = [];

  for (let i = 0; i < result.snapshotLength; i++) {
    const element = result.snapshotItem(i) as HTMLElement | null;

    if (element) {
      elements.push(element);
    }
  }

  // For partial matches, we need to be more careful about filtering
  // We want to keep elements that contain the text, even if their children also contain it
  // But we should prioritize more specific matches when possible
  console.log('elements', elements);
  return elements.filter((element) => {
    // Check if any child element also matches
    const hasMatchingChild = elements.some(
      (other) => other !== element && element.contains(other)
    );

    // For exact matches, prefer leaf nodes
    const elementText = element.textContent || "";
    const isExactMatch = elementText === searchText;

    if (isExactMatch) {
      // For exact matches, prefer leaf nodes (no matching children)
      return !hasMatchingChild || element.children.length === 0;
    } else {
      // For partial matches, keep the element if it contains the text
      // This allows us to create boundaries around the specific text
      return true;
    }
  });
}
/**
 * Convenience wrapper function
 */
export function findElementsByText(searchText: string, options: { rootElement?: Document | HTMLElement; deepSearch?: boolean } = {}) {
  const { deepSearch = true } = options;

  if (deepSearch) {
    return searchWithXPathDeep(searchText);
  }

  return [];
}

